import { Heading, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { Control, FieldValues, UseFormWatch } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../../utils/styles/styles";
import RadioControlGroup from "../../../../components/molecule/RadioControlGroup/RadioControlGroup";
import { getIndicatorVariation } from "../../../../services/Indicator/getIndicatorVariation";

interface ReadingIndicatorVariationsFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  watch: UseFormWatch<FieldValues>;
}

const ReadingIndicatorVariationsForm: FC<
  ReadingIndicatorVariationsFormProps
> = ({ errors, control, isDisabled, watch }) => {
  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Leitura das Variações do Indicador
      </Heading>
      <RadioControlGroup
        errors={errors}
        control={control}
        fetchOptions={getIndicatorVariation}
        fieldName="O aumento dos valores deste indicador:"
        name="indicatorVariationsOption"
        isRequired
        isDisabled={isDisabled}
      />
    </Stack>
  );
};

export default ReadingIndicatorVariationsForm;
